export default __webpack_public_path__ + "images/3f0a21d2f093220f54c82238ed307ea3.svg";